import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { generateCertificatePDF } from '../services/CertificateService';
import { Download, Award } from 'lucide-react';

const CertificateSection: React.FC = () => {
  const [participant, setParticipant] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkEligibility = async () => {
      if (auth.currentUser) {
        // Obtener datos del participante y configuración del evento
        const [docSnap, settingsSnap] = await Promise.all([
          getDoc(doc(db, 'participantes', auth.currentUser.uid)),
          getDoc(doc(db, 'settings', 'main'))
        ]);

        if (docSnap.exists() && settingsSnap.exists()) {
          const data = docSnap.data();
          const settings = settingsSnap.data();
          
          const attendanceCount = Object.values(data.asistencia || {}).filter(a => a === true).length;
          const deadlineDate = settings.registrationDeadline ? new Date(settings.registrationDeadline) : null;
          const now = new Date();

          // Condición unificada: 2+ días asistidos Y periodo de inscripción finalizado
          if (attendanceCount >= 2 && (deadlineDate ? now > deadlineDate : true)) {
            setParticipant(data);
          }
        }
      }
      setLoading(false);
    };
    checkEligibility();
  }, []);

  if (loading) return null;
  if (!participant) return null;

  return (
    <div className="certificate-banner" style={{
      background: 'linear-gradient(135deg, #1B4332 0%, #2D4F3E 100%)', // Verde Bosque Profundo
      color: 'white',
      padding: '2.5rem',
      borderRadius: '16px',
      marginTop: '3rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: '1.5rem',
      boxShadow: '0 10px 25px rgba(27, 67, 50, 0.2)',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <Award size={60} style={{ color: '#FFD700' }} /> {/* Icono en Oro */}
      <div>
        <h3 style={{ color: 'white', marginBottom: '0.5rem', fontSize: '1.6rem' }}>Parabéns, {participant.name}!</h3>
        <p style={{ opacity: 0.9, fontSize: '1.1rem' }}>Você completou a carga horária mínima e seu certificado está pronto.</p>
      </div>
      <button 
        onClick={() => generateCertificatePDF(participant.name, "Evento Internacional GIEPEI", participant.modality || "Presencial")}
        className="btn"
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '10px', 
          background: '#FFD700', // Botón en color Oro
          color: '#1B4332', 
          fontWeight: '700',
          padding: '0.8rem 2rem',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
        }}
      >
        <Download size={20} />
        Baixar Certificado PDF
      </button>
    </div>
  );
};

export default CertificateSection;
